import "#legacy/application/forms/international_phone_input.js";
import "#legacy/application/components/form_modal.js";

const sparkleContainer = "[data-sparkle-container]";
const formContainer = "[data-form~='container']";
const formModalSelector = "[data-behaviour~='open-form-modal']";
const formTextSelector = "[data-context-name='text']";
const footerTextSelector = "[data-context-name='footer']";
const inelgibleOptionSelector = "[data-eligibility='ineligible']"; // This should match the Eligibility Check form builder field config
const submitSelector = "input[type='submit']";
const eligibilityMessageAttribute = "data-eligibility-message";
const eligibilityMessageCSSClass = "field-alert-message";
const elligibilityContainerSelector = ".elligibility"; // This should match the Eligibility Check form builder field template

// Unregistered because it is an abstract class.
Sparkle.PageBuilder.Components.FormAbstractBehavior = class FormAbstractBehavior extends (
  Sparkle.PageBuilder.Components.Behavior
) {
  static {
    this.prototype.events = {
      "click [data-behaviour~='open-form-modal']": "handleOpenFormModalClick",
      change: "updateEligibility",
    };
    // Check on any change because selecting a radio button that doesn't specify eligibility won't trigger a change when it forces the ineligible option to unselect
  }

  constructor() {
    super(...arguments);
    this.onRender = this.onRender.bind(this);
    this.initialize = this.initialize.bind(this);
    this.onFirstVisible = this.onFirstVisible.bind(this);
    this.mobileCTAActivateOverride = this.mobileCTAActivateOverride.bind(this);
    this.disableSubmit = this.disableSubmit.bind(this);
    this.removeElgibilityMessages = this.removeElgibilityMessages.bind(this);
    this.showEligibilityMessage = this.showEligibilityMessage.bind(this);
    this.openModal = this.openModal.bind(this);
    this.mobileCTAActivate = this.mobileCTAActivate.bind(this);
    this.createFormModal = this.createFormModal.bind(this);
    this.createTeaserFormModal = this.createTeaserFormModal.bind(this);
    this.initializeFormPhoneInputs = this.initializeFormPhoneInputs.bind(this);
    this.initializeFormDateInputs = this.initializeFormDateInputs.bind(this);
    this.formModalOptions = this.formModalOptions.bind(this);
  }

  onRender() {
    this.initialize();
    return this.initializeFormPhoneInputs(this.form);
  }

  initialize() {
    this.form = this.el.find(formContainer).find("form");
    this.prefixFormContent = this.el.find(formTextSelector).clone();
    this.footerFormContent = this.el.find(footerTextSelector).clone();
    this.recaptchaDisclaimer = this.el.find(".recaptcha-disclaimer").clone();
    this.showFormInModalTrigger = this.el.find(formModalSelector);
    return this.updateEligibility();
  }

  onFirstVisible() {
    return this.initializeFormPhoneInputs(this.form);
  }

  mobileCTAActivateOverride() {
    if (this.showFormInModalTrigger != null ? this.showFormInModalTrigger.length : undefined) {
      return true;
    }
  }

  // EVENT HANDLERS

  handleOpenFormModalClick(event) {
    return this.openModal();
  }

  // HELPER FUNCTIONS

  updateEligibility() {
    this.removeElgibilityMessages();
    const selectedInelgibleChoices = this.el.find(inelgibleOptionSelector).filter(":checked");
    selectedInelgibleChoices.each((index, element) => this.showEligibilityMessage(element));
    return this.disableSubmit(selectedInelgibleChoices.length > 0);
  }

  disableSubmit(state = true) {
    return this.el.find(submitSelector).attr("disabled", state);
  }

  removeElgibilityMessages() {
    return this.el.find(`.${eligibilityMessageCSSClass}`).remove();
  }

  showEligibilityMessage(element) {
    const text = $(element).attr(eligibilityMessageAttribute);
    const target = $(element).closest(elligibilityContainerSelector);
    if (text && target.length) {
      return $("<sp-alert>", { class: eligibilityMessageCSSClass, type: "info", compact: true })
        .text(text)
        .appendTo(target);
    }
  }

  openModal() {
    if (this.modal != null) {
      return this.modal.show();
    }
    return this.createFormModal().then(() => this.modal.show());
  }

  mobileCTAActivate() {
    if (this.teaserModal != null) {
      return this.teaserModal.show();
    }
    return this.createTeaserFormModal().then(() => this.teaserModal.show());
  }

  createFormModal() {
    return jQuery.when().then(() => {
      const form = this.form.clone();
      this.initializeFormPhoneInputs(form);
      this.initializeFormDateInputs(form);
      return (this.modal = new FormModal(form, this.formModalOptions()));
    });
  }

  createTeaserFormModal() {
    return jQuery.when().then(() => {
      const form = this.form.clone();
      this.initializeFormPhoneInputs(form);
      this.initializeFormDateInputs(form);
      return (this.teaserModal = new FormModal(form, this.formModalOptions()));
    });
  }

  initializeFormPhoneInputs(form) {
    return window.Sparkle.Forms.loadInternationalPhoneInput(form.find(".phone-mask"));
  }

  initializeFormDateInputs(form) {
    return form.find(".date-mask").mask("09/09/0000");
  }

  formModalOptions() {
    this.prefixFormContent.show();
    this.footerFormContent.show();
    const options = {
      title: this.showFormInModalTrigger.data("modal-title"),
      prefixFormContent: this.prefixFormContent,
      footerFormContent: this.footerFormContent,
      review: this.showFormInModalTrigger.data("modal-review"),
      appendTo: this.el.closest(sparkleContainer),
    };

    if (this.form.data("recaptcha")) {
      this.recaptchaDisclaimer.show();
      options.recaptchaDisclaimer = this.recaptchaDisclaimer;
    }

    return options;
  }
};
